<script>
export default {
  name: 'SamplesTopDescription',
};
</script>

<template>
  <div>
    <p>
      Not sure what yumminess to explore? Want to try a smaller size before indulging big time?
      Check out these tasty samples below!
      <b>Most samples are $2.50!</b>
    </p>
    <p>
      Looking for a variety of goodies? Check out our
      <a href="/sampler-packs" class="underline">sampler packs</a>.
    </p>
  </div>
</template>
